import { createSelector } from '@reduxjs/toolkit';

import {
  AUTOJOIN_SIDEBAR,
  FAVORITES,
  INVITE_CREATOR_ACTION,
  INVITE_VIEWER_ACTION,
  PERSONAL_ARCHIVE_READ,
  PERSONAL_ARCHIVE_WRITE,
  PERSONAL_LIBRARY_READ,
  PERSONAL_LIBRARY_WRITE,
  SEARCH_ACCESS,
  SHARED_LIBRARY_READ,
  SHARED_LIBRARY_WRITE,
  SUGGESTED_WORKSPACE_SIDEBAR,
  TEAM_ARCHIVE_READ,
  TEAM_ARCHIVE_WRITE,
  TEAM_LIBRARY_READ,
  TEAM_LIBRARY_WRITE,
  WATCH_LATER,
  WORKSPACE_DOMAIN_JOIN_MANAGE,
} from 'constants/scopes';

import { selectUserScopes } from './scopes';

export const selectNavigationScopes = createSelector(
  selectUserScopes,
  scopes => ({
    hasSharedLibraryReadScope: scopes.includes(SHARED_LIBRARY_READ),
    hasSharedLibraryWriteScope: scopes.includes(SHARED_LIBRARY_WRITE),
    hasPersonalArchiveReadScope: scopes.includes(PERSONAL_ARCHIVE_READ),
    hasPersonalArchiveWriteScope: scopes.includes(PERSONAL_ARCHIVE_WRITE),
    hasTeamArchiveReadScope: scopes.includes(TEAM_ARCHIVE_READ),
    hasTeamArchiveWriteScope: scopes.includes(TEAM_ARCHIVE_WRITE),
    hasPersonalLibraryReadScope: scopes.includes(PERSONAL_LIBRARY_READ),
    hasPersonalLibraryWriteScope: scopes.includes(PERSONAL_LIBRARY_WRITE),
    hasTeamLibraryReadScope: scopes.includes(TEAM_LIBRARY_READ),
    hasTeamLibraryWriteScope: scopes.includes(TEAM_LIBRARY_WRITE),
    hasSearchAccessScope: scopes.includes(SEARCH_ACCESS),
    hasWorkspaceJoinManageScope: scopes.includes(WORKSPACE_DOMAIN_JOIN_MANAGE),
    hasWatchLaterScope: scopes.includes(WATCH_LATER),
    hasFavoritesScope: scopes.includes(FAVORITES),
    hasInviteViewerActionScope: scopes.includes(INVITE_VIEWER_ACTION),
    hasInviteCreatorActionScope: scopes.includes(INVITE_CREATOR_ACTION),
    hasSuggestedWorkspaceSidebarScope: scopes.includes(
      SUGGESTED_WORKSPACE_SIDEBAR
    ),
    hasAutojoinSidebarScope: scopes.includes(AUTOJOIN_SIDEBAR),
  })
);
